module.exports = __webpack_public_path__ + "static/media/mercuryzone--background.e99db434.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/mercuryzone/mercuryzone--background.jpg
// module id = 160
// module chunks = 0